import { useEffect } from "react";

import { useUnifiedRegistry } from "@/components/UnifiedRegistry/unified-registry-context";
import { RegistryItem } from "@/components/UnifiedRegistry/types";
import { isModifierKeyPressed } from "@/utils/shortcuts";

export const useSidebarSelectionKeyboard = (allItems: RegistryItem[]) => {
  const registry = useUnifiedRegistry();

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      const target = event.target as HTMLElement;
      if (target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable) {
        return;
      }

      if (event.key === "Escape") {
        registry.clearSelection();
        return;
      }

      if (isModifierKeyPressed(event) && event.key === "a") {
        event.preventDefault();
        registry.selectEntities(allItems);
        return;
      }

      if (isModifierKeyPressed(event) && event.key === "d") {
        event.preventDefault();
        registry.clearSelection();
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [registry, allItems]);
};
